import { DateTime } from "luxon";

export default (lastMessage) => {
    const dateNow = DateTime.now();

    if (!lastMessage) return dateNow.toISO();
    const lastMessageISODate = DateTime.fromISO(lastMessage.status.sentAt);

    const sentAt =
        dateNow > lastMessageISODate
            ? dateNow.toISO()
            : lastMessageISODate.plus(100).toISO();

    return sentAt;
};
